<template>
  <div class="mw-panel">
    <toolbar-table ref="toolbarTable" :applicationId="applicationId" :layout="layout"></toolbar-table>
  </div>
</template>
<script>
  export default {
    name: 'MwViewToolbarTable',
    props: {
      layout: Array,
      applicationId: {
        type: String
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/common/components/extend/view/toobarTable.vue